/* Goldgums-shoppagina: filteren op doel (pills) en sorteren via Shopify sort_by. */
(() => {
  document.querySelectorAll('[data-gg-shop2]').forEach((root) => {
    const pills = [...root.querySelectorAll('.gg-pill')];
    const cards = [...root.querySelectorAll('[data-gg-grid] > .gg-card')];
    const choose = (goal) => {
      pills.forEach((p) => p.setAttribute('aria-pressed', String(p.dataset.goal === goal)));
      let visible = 0;
      cards.forEach((c) => { const on = !goal || c.dataset.goal === goal; c.hidden = !on; if (on) visible++; });
      root.querySelectorAll('[data-gg-visible]').forEach((el) => { el.textContent = visible; });
      root.querySelector('[data-gg-empty]').hidden = visible > 0;
      const url = new URL(location.href);
      if (goal) url.searchParams.set('doel', goal); else url.searchParams.delete('doel');
      history.replaceState(null, '', url);
    };
    pills.forEach((p) => p.addEventListener('click', () => choose(p.dataset.goal)));
    root.querySelector('[data-gg-show-all]')?.addEventListener('click', () => choose(''));
    root.querySelector('[data-gg-sort]')?.addEventListener('change', (e) => {
      const url = new URL(location.href); url.searchParams.set('sort_by', e.target.value); location.href = url.toString();
    });
    const start = new URL(location.href).searchParams.get('doel');
    if (start && pills.some((p) => p.dataset.goal === start)) choose(start);
  });
})();